import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import { Form, Grid, Header, Button, Icon } from 'semantic-ui-react'
import { FormValidation, Field, FileBase64 } from '../components'
import { fields } from '../../common/lib/redux-fields'
import { pdfAttendanceSave } from '../../common/attendances/actions'
import { validateFile, } from '../../common/attendances/validations'

const { Row, Column } = Grid

class AttendanceOwnPdfForm extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {selectedFile: null}
  }

  async submit(e) {
    e.preventDefault()
    const { fields, submit, attendance, pdfAttendanceSave } = this.props
    const { selectedFile } = this.state
    const values = fields.$values()
    if (selectedFile) {
      values['file_name'] = selectedFile.name
      values['file_type'] = selectedFile.type
      values['file_size'] = selectedFile.size
      values['file_data'] = selectedFile.base64
	} else {
      values['file_name'] = null
      values['file_type'] = null
      values['file_size'] = null
      values['file_data'] = null
	}
	
    if (attendance && !!attendance._id) {
      values['_id'] = attendance._id
	} else {
      values['_id'] = null
	}

	await submit(values, pdfAttendanceSave)
  }

  componentWillMount() {
  }

  componentWillUnmount() {
    this.props.fields.$reset()
  }

  uploadHandler = (e) => {
    this.setState({selectedFile:e})
  }

  render() {
    const { fields, attendance, submitting, submitSuccessfull, errors, errorMessage } = this.props

    if (submitSuccessfull && attendance && attendance._id) return <Redirect to={'/attendances/' + attendance._id} />
    if (submitSuccessfull) return <Redirect to='/attendances/' />
	
    const fieldData = Object.assign({}, fields)
    errors.forEach(error => {
      if (error.detail && error.detail.field && fieldData[error.detail.field]) {
        fieldData[error.detail.field].error = error.message
      }
    })

    return (
      <Form loading={submitting} size="big">
        <Grid>
          <Row>
            <Column>
              <Header as="h2"><Icon name="file" color="grey" /> Připojit vlastní PDF</Header>
            </Column>
          </Row>
          {attendance && attendance.pdf && attendance.pdf.length > 0 &&
          <Row>
            <Column>
              <Icon name="exclamation triangle" size="large" color="red" /> POZOR: Stávající PDF bude nahrazeno!
            </Column>
          </Row>
          }
          <FileBase64 accept="application/pdf" onDone={(e)=>this.uploadHandler(e)} />
          <Field type="checkbox" label="Označit prezenci jako 'provedena'" {...fieldData.markDone} />
        </Grid>

        {errorMessage}

        <Grid>
          <Row>
            <Column>
              {attendance && attendance._id &&
                <Link to={"/attendances/" + attendance._id}><Button>Storno</Button></Link>
              }
              <Button type="submit" color="red" onClick={(e)=>this.submit(e)}> Uložit </Button>
            </Column>
          </Row>
        </Grid>
      </Form>
    )
  }
}

AttendanceOwnPdfForm.defaultProps = {
  attendance: null,
  submitting: false,
  submitSuccessfull: false,
  errors: [],
  errorMessage: null,
}

AttendanceOwnPdfForm.propTypes = {
  fields: React.PropTypes.object.isRequired,
  attendance: React.PropTypes.object,
  selectedFile: React.PropTypes.object,
  submitting: React.PropTypes.bool,
  submitSuccessfull: React.PropTypes.bool,
  errors: React.PropTypes.array,
  errorMessage: React.PropTypes.any
}

AttendanceOwnPdfForm = fields(AttendanceOwnPdfForm, {
  path: 'AttendanceOwnPdfForm',
  fields: ['markDone'],
  getInitialState: (props) => {
    const { attendance } = props
    if (attendance && attendance._id) return attendance.toJS()
    return { selectedFile: null, markDone: false }
  },
})

AttendanceOwnPdfForm = FormValidation(AttendanceOwnPdfForm, (props) => {
  const { attendance } = props
  let submissionValidation = validateFile
  return { submissionValidation }
})

export default connect((state) => ({
  viewer: state.attendances.viewer,
  attendance: state.attendances.current,
}), { pdfAttendanceSave })(AttendanceOwnPdfForm)



// WEBPACK FOOTER //
// ./src/browser/forms/AttendanceOwnPdf.js